import React, { useState, useEffect } from "react";
import apiCall from "../../API/API";
import { toast } from "react-toastify";
import { CiCirclePlus } from "react-icons/ci";
import { Row, Col, Container, Button } from "react-bootstrap";
import { useDispatch, useSelector } from "react-redux";
import { fetchApiRoutes } from "../../Actions/adminActions"; 
import routesData from "../../Sidebar/Routes.json"

const BonusIncomeSetting = () => {
  const [bonusIncome, setBonusIncome] = useState();
  const dispatch = useDispatch();

  const fetchIcon = async () => {
    try {
      const { data, error } = await apiCall("GET", "/getAllPackage");
      if (data) {
        console.log("data----", data?.packages[0]?.bonus_income?.level[0]?.income);
        setBonusIncome(data?.packages[0]?.bonus_income?.level[0]?.income);
      }
    } catch (e) {
      console.log(e.message);
    }
  };

  useEffect(() => {
    fetchIcon();
  }, []);

  const handleUpdate = async () => {
    try {
      const body = { bonus_Income: bonusIncome };
      console.log("body", body);
      const { data, error } = await apiCall("POST", `/update-bonus-income`, body);
      if (error) {
        toast.error(error.message || "An error occurred");
      } else {
        toast.success(data.message || "Bonus income updated successfully!");
        fetchIcon();
      }
    } catch (error) {
      toast.error(error.message || "An error occurred");
    }
  };

  const { routes } = useSelector((state) => state.admin);
  const [permissions, setPermissions] = useState({});
    
  var x = 0;
  useEffect(() => {
    if (x === 0) dispatch(fetchApiRoutes());
    x++;
  }, [dispatch]);

  useEffect(() => {
    if (routes?.routes?.length > 0) {
      const updatedPermissions = {};
      // console.log("local routes", routesData);
      routesData.forEach((localRoute) => {
        // console.log("api routes", routes);
        const match = routes?.routes.find(
          (apiRoute) =>
            apiRoute.path === localRoute.path &&
            apiRoute.showInMenu === localRoute.showInMenu
        );

        if (match) {
          // console.log(`Matched Route:`, localRoute.path);
          updatedPermissions[localRoute.stateKey] = true; // Enable section
        }
      });
      console.log("updatedPermissions", updatedPermissions);
      setPermissions(updatedPermissions);
      // console.log(permissions);
    }
  }, [routes]);
  
  return (
    <React.Fragment>
      <Container>
        <div className="bonanza-settings">
          <div className="input-row1">
            <h2>Bonus Income</h2>
            <div className="input-group2">
              <label>Income:</label>
              <input
                type="number"
                name="income"
                placeholder="Enter Income"
                value={bonusIncome}
                disabled={!permissions?.setBonusIncome}
                onChange={(e) => setBonusIncome(e.target.value)}
                required
              />
            </div>
            {permissions?.setBonusIncome &&(
            <div className="button-container">
              <Button type="submit" variant="primary" onClick={handleUpdate}>
                Update
              </Button>
            </div>
            )}
          </div>
        </div>
      </Container>
    </React.Fragment>
  );
};

export default BonusIncomeSetting;